// src/pages/Courses.js
import React from "react";
import "./PageStyles.css";

const Courses = () => {
  return (
    <section className="page-section">
      <h1>Courses</h1>
      <p>Explore our academic programs and debate training modules tailored for aspiring delegates.</p>
      <ul>
        <li>Public Speaking Essentials</li>
        <li>UN Procedures & Rules</li>
        <li>Leadership & Diplomacy Workshop</li>
      </ul>
    </section>
  );
};

export default Courses;
